const DIRECTION_TYPES = {
  DESTINATION: 'DESTINATION',
  DEPARTURE: 'DEPARTURE',
};
export default DIRECTION_TYPES;
